module.exports = __webpack_public_path__ + "static/31-4fb620452f7fd96c844df7e2c252f4bc.jpg";